import React, { useState } from "react";
import {
  Paper,
  Typography,
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Button,
  Box,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import "./collectStatus.css";

const CollectStatus = () => {
  const [mode, setMode] = useState("ref");
  const [collectRef, setCollectRef] = useState("");

  const fees = 100;

  const onSubmit = () => {
    console.log("Submitted values:");
    console.log("Mode:", mode);
    console.log("Collect Ref:", collectRef);
    switch (mode) {
      case "ref":
        //call service method with 
        
        break;
      case "utr":
        break;
      case "crn":
        break;
    }
  };
  console.log(mode);

  return (
    <Paper elevation={1} className={"tableContainer"}>
      <Typography className={"masterBalance"}>
        <span style={{ color: "#79747E", paddingRight: "5px" }}>
          Get collect status
        </span>
      </Typography>

      <Box className={"formContainer"}>
        <Typography className={"type"}>Select Mode</Typography>
        <FormControl component="fieldset" sx={{ marginLeft: 2 }}>
          <RadioGroup
            row
            name="transaction-type"
            value={mode}
            onChange={(e) => setMode(e.target.value)}
          >
            <FormControlLabel value="ref" control={<Radio />} label="Ref" />
            <FormControlLabel value="crn" control={<Radio />} label="CRN" />
            <FormControlLabel value="utr" control={<Radio />} label="UTR" />
          </RadioGroup>
        </FormControl>

        <TextField
          id="outlined-basic"
          label={`Enter ${mode === "crn" ? "CRN" : mode === "ref" ? "REF" : "UTR"} `}
          variant="outlined"
          value={collectRef}
          onChange={(e) => setCollectRef(e.target.value)}
          sx={{ borderRadius: "8px", backgroundColor: "#fff" }}
        />

        <Box className={"submitContainer"}>
          <Button
            variant="contained"
            className={"submitButton"}
            onClick={onSubmit}
          >
            Search
          </Button>
        </Box>

        <div className={"border"}>
          <Typography className={"statusCollect"}>
            <span style={{ color: "#79747E", paddingRight: "5px" }}>
              collect status
            </span>
          </Typography>
          <Box className={"row"}>
            <Typography className={"label"}>Collect ref</Typography>
            <Typography className={"colon"}>:</Typography>
            <Typography className={"value"}>₹{fees.toFixed(2)}</Typography>
          </Box>
          <Box className={"row"}>
            <Typography className={"label"}>UTR</Typography>
            <Typography className={"colon"}>:</Typography>
            <Typography className={"value"}>{"424414449279"}</Typography>
          </Box>
          <Box className={"row"}>
            <Typography className={"label"}>Status</Typography>
            <Typography className={"colon"}>:</Typography>
            <Typography className={"value"}>{"Processed"}</Typography>
          </Box>
          <Box className={"row"}>
            <Typography className={"label"}>Bank Resposne</Typography>
            <Typography className={"colon"}>:</Typography>
            <Typography className={"value"}>{"N/A"}</Typography>
          </Box>
        </div>
      </Box>
    </Paper>
  );
};

export default CollectStatus;
